import PropTypes from 'prop-types'
import React from 'react'
import Trans from 'next-translate/Trans'
import config from 'SRC/config/config.json'

export const PaidLimit = ({ packages }) => {
  const text = config.registrationForm.package.paidLimit

  return (
    <tr>
      <Trans
        i18nKey='common:packages_paidLimit_text'
        components={{
          td: <td />,
          strong: <strong />
        }}
        defaultTrans='<td>Broj <strong>GRATIS plaćenih</strong> oglasa mjesečno</td>'
      />
      {packages.map(item => <td key={item.id}>{Number(item.paidLimit)}</td>)}
    </tr>
  )
}
PaidLimit.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    paidLimit: PropTypes.number
  })).isRequired
}

PaidLimit.defaultProps = {
  packages: []
}
